import { toPayRequestUrl } from '@arkade-os/lnurl-client'

// The payer path lives in @arkade-os/lnurl-client. What remains here is
// fetchArkAddress, which calls the callback with ?method=ark — a parameter the
// Arkade lnurl-server does not implement, so the package has no equivalent by
// design. Removing it would change behaviour for whichever provider it does
// serve, so it stays until then.

type ArkMethodResponse = {
  expiryDate: string
  address: string
  hint: string
}

const checkResponse = async <T = any>(response: Response): Promise<T> => {
  if (!response.ok) return Promise.reject(response)
  const data = await response.json()
  if (data.status === 'ERROR') return Promise.reject(data.reason || 'LNURL error')
  return data
}

export const fetchArkAddress = (lnurl: string): Promise<ArkMethodResponse> => {
  return new Promise<ArkMethodResponse>((resolve, reject) => {
    const url = new URL(toPayRequestUrl(lnurl).url)
    url.searchParams.set('method', 'ark')
    fetch(url)
      .then(checkResponse<ArkMethodResponse>)
      .then(resolve)
      .catch(reject)
  })
}
